import * as React from "react";
import * as ReactDOM from "react-dom";
import * as styles from "../../styles.scss";
import { tl } from "../../../../utils";

interface IStatisticProps {
  value: any;
}

export const Statistic = (props: IStatisticProps) => {
  if(props.value.length === 0 || props.value[0].value.length === 0){
    return (
      <div>
        <span className={styles.answerTitle}>Не был дан ответ</span>
        <div>
          <b>Пропущен!</b>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.answerBlock}>
      <div className={styles.answerTitle}>{tl('Ответ.')}</div>
      {props.value.map((stat: any, i: number) => (
        <div key={i}>
          {stat.field} - <span className={styles.answerTitleInline}>{stat.value}</span>
        </div>
      ))}
    </div>
  );
};
